import { render, staticRenderFns } from "./Puzzles.vue?vue&type=template&id=4270cf27&"
import script from "./Puzzles.vue?vue&type=script&lang=js&"
export * from "./Puzzles.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports